import { FALLBACK } from "components/metric-card";

export const NEUTRAL_TOOLTIP_COLORS = {
  ...FALLBACK,
  tooltipBg: "#EFF6FF",
  tooltipText: "#334155",
};

export const CELL_FONT_SX = {
  "& .MuiInputBase-input": { fontSize: "14px" },
  "& .MuiSelect-select": { fontSize: "14px" },
};
